import React from 'react';
import { CheckBox } from '../../utils/components';
import { formatUSdate } from '../../utils/constants';

const RegisteredItem = ({
  product,
  index,
  selectedItem,
  isChecked,
  onSelectItem,
}) => {
  const isSelected = selectedItem ? selectedItem.id === product.id : false;

  return (
    <div
      className={`case-items-row ${
        isSelected ? 'case-items-row-selected' : ''
      }`}
      data-id={product.id}
      data-index={index}
      onClick={onSelectItem}
    >
      <CheckBox checked={isChecked} />
      <div className='case-items-row-options'>
        <div className='case-items-row-container'>
          <p className='case-items-row-option'>
            <span className='case-items-row-option-header'>Name:</span>
            <span className='case-items-row-option-value'>{product.name}</span>
          </p>
          <p className='case-items-row-option'>
            <span className='case-items-row-option-header'>
              Place of Purchase:
            </span>
            <span className='case-items-row-option-value'>
              {product.marketplace}
            </span>
          </p>
        </div>
        <div className='case-items-row-container'>
          <p className='case-items-row-option'>
            <span className='case-items-row-option-header'>Purchase date:</span>
            <span className='case-items-row-option-value'>
              {formatUSdate(new Date(product.purchase_date))}
            </span>
          </p>
          <p className='case-items-row-option'>
            <span className='case-items-row-option-header'>Order Number:</span>
            <span className='case-items-row-option-value'>
              {product.order_number}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisteredItem;
